import { ROLES } from 'src/constants';

// ----------------------------------------------------------------------

// The roles the general dashboard has cards for (src/sections/dashboard/view/dashboard-view.jsx)
const DASHBOARD_CARD_ROLES = [
  ROLES.SCHOOL_ADMIN,
  ROLES.USER_ROLE_TRANSPORTATION_ADMIN,
  ROLES.USER_ROLE_TRANSPORTATION_MANAGER,
  ROLES.SUPER_ADMIN,
];

// Where a signed-in staff user lands. The first match wins: principals and
// finance go to the school dashboard, home ed staff to home ed, an off-campus
// coordinator to the Off Campus overview (even one who is also a counsellor),
// and a counsellor to the Careers dashboard, their home (#612). An off-campus
// secretary goes to the Off Campus overview too. Off-campus staff with cards on
// the general dashboard (a school secretary with User.Admin keeps their
// enrollments and profile reviews) stay there. Everyone else lands on the
// general dashboard.
export function landingPath(roles) {
  const has = (...wanted) => Array.isArray(roles) && wanted.some((r) => roles.includes(r));

  const hasDashboardCards = has(...DASHBOARD_CARD_ROLES);

  if (has(ROLES.USER_ROLE_SCHOOL_PRINCIPAL, ROLES.USER_ROLE_FINANCE_ADMIN)) return '/school-dashboard';
  if (has(ROLES.HOMESCHOOL_ADMIN, ROLES.HOMESCHOOL_FACILITATOR)) return '/home-ed';
  if (has(ROLES.USER_ROLE_OFF_CAMPUS_COORDINATOR) && !hasDashboardCards) return '/off-campus';
  if (has(ROLES.USER_ROLE_COUNSELOR)) return '/careers-dashboard';
  if (has(ROLES.USER_ROLE_OFF_CAMPUS_SECRETARY) && !hasDashboardCards) return '/off-campus';
  return '/dashboard';
}
